import { render } from "./Projections.vue?vue&type=template&id=8b533f16&scoped=true"
import script from "./Projections.vue?vue&type=script&lang=js"
export * from "./Projections.vue?vue&type=script&lang=js"

import "./Projections.vue?vue&type=style&index=0&id=8b533f16&lang=css"
import "./Projections.vue?vue&type=style&index=1&id=8b533f16&scoped=true&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b533f16"]])

export default __exports__